<template>
  <div>
    <el-dialog
      class="dialogNotify"
      :show-close="false"
      center
      :visible.sync="isShowDialog"
      :before-close="handleClose"
      :height="dialogMinHeight"
      :bottom="0"
    >
      <div class="mb-20">
        <div style="position:relative;">
          <div
            style="padding-bottom: 0 !important;"
            class="container d-flex justify-content-center mt-3"
          >
            <p class="title-dialog m-0">{{ title }}</p>
            <img
              style="position: absolute; right:20px"
              @click="handleClose"
              :src="bg.icon_closed"
              alt=""
            />
          </div>
          <div
            style="padding-top: 16px;min-height:15vh"
            class="full-width container"
          >
            <p
              style="word-break: keep-all; "
              class="text-center"
              v-html="message"
            ></p>
          </div>
          <div class="d-flex justify-content-center">
            <button-customer
              :styles="{
                width: '120px',
                fontSize: '12px',
                fontWeight: 500,
                height: '30px',
                borderRadius: '5px',
                padding: '5px 0px'
              }"
              :object-data="{ title: $t('wap.text42') }"
              @on-action="handleClose"
            />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBackGround } from "@/utils/wapAuth";
import { toggleChat } from "@/utils/helper";
import ButtonCustomer from "@/components/wapV2/button/index.vue";

export default {
  name: "dialogNotify",
  components: {
    ButtonCustomer
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    isViewsPrice: {
      type: Boolean,
      default: false
    },
    title: {
      default: "Thông báo"
    },
    message: {
      default: ""
    }
  },

  data() {
    return {
      isLoading: false,
      bg: getBackGround(),
      isMobile: true,
      icons: {}
    };
  },
  created() {},

  computed: {
    dialogMinHeight() {
      return window.innerHeight * 0.9 + "px";
    }
  },
  watch: {
    isShowDialog: function(newValue, oldValue) {
      if (newValue) {
        toggleChat(false);
        if (this.listPackage.length > 0) return;
        this.getListPackage();
      } else {
        toggleChat(true);
      }
    }
  },
  mounted() {},
  methods: {
    handleAction() {
      this.handleClose();
    },
    handleClose() {
      this.$emit("close", true);
    }
  }
};
</script>
<style lang="scss">
$color_slider: v-bind("bg.c_button_main");
$color_radio_check: v-bind("bg.c_button_main");
$color_slider_bar: #d9d9d9;

.mt-15 {
  margin-top: 15px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.dialogNotify .el-dialog {
  position: relative;
  border-radius: 10px;
  min-height: 20vh;
  overflow: hidden;
  max-width: 450px !important;
  min-width: 350px;
  z-index: 2100;
  margin-bottom: 0 !important;
  margin-top: 20vh !important;

  .el-dialog__body {
    padding-top: 0 !important;
    padding-bottom: 0px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .el-dialog__header {
    margin: 0;
    padding: 0;
  }
}
.el-tooltip__popper {
  display: none !important;
}
</style>

<style lang="scss" scoped>
$divider-color: #ececec;

$color-btn: v-bind("bg.c_button_main");
.title-dialog {
  color: var(--Foreground-Ink-Default, #1a1a1a);
  font-weight: 600;
  font-size: 14.56px;
  line-height: 19.41px;
  letter-spacing: 0%;
}

.w-100 {
  width: 100%;
}
.mr-10 {
  margin-right: 10px;
}
</style>
